module.exports = __webpack_public_path__ + "static/media/moveSoundEffect.43e6bf62.mp3";